import { Injectable, inject } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import {Webservice} from './webservice';

@Injectable({
    providedIn: 'root'
})
export class SearchWebservice extends Webservice {
    private readonly httpBypass = new HttpClient(inject(HttpBackend));

    constructor() {
        super();
        this.entity = 'search';
    }

    getPlacesTree(dep: number = 0) {
        return this.httpBypass.get(`${this.root}/user/places/inscription?dep=${dep}`);
    }
}
